import React from "react";
import PropTypes from "prop-types";
import Select from 'react-select';
import { useEffect } from "react";
import "./_reactSelect.scss";

function SelectComponent(Props) {
  const {
    handleChange,
    options,
    optionValues,
    name,
    selectedValue,
    disabled,
    required,
    placeholder,
    className,
    multiple,
    label,
    labelClass
  } = Props;
  const optionsId = options.map(a => a.skill_id);
  const optionsData = () => {
    if(name === 'skills') {
      return options.map(a => {
        return {
          value: a.skill_id,
          label: a.skillName
        }
      }) 
    } else {
        return options.map(a => {
          return {
            value: a,
            label: a
          }
        })
    }
  }

  const handleFieldChange = (data) => {
    handleChange(data.value, name)
  }

  const selectedOptionValue = optionsData().find(a => a.value == selectedValue) || null;
  return (
    <>
      <Select
        classNamePrefix="reactSelect" 
        placeholder={placeholder || "Select"}  
        required={required}
        disabled={disabled}
        className={'reactSelect-container ' + className}
        onChange={handleFieldChange}
        name={name}
        isSearchable={false} 
        options={optionsData()}
        value={selectedOptionValue}
        multiple={multiple}
      />

      {/* <select
        required={required}
        disabled={disabled}
        className={'select-box ' + className}
        onChange={handleChange}
        name={name}
        value={selectedValue}
        multiple={multiple}
      >
        {placeholder && (
          <option value="" key={placeholder}>
            {placeholder}
          </option>
        )}
        {name === 'skills' ? options.map((val, ind) => {
            if(optionsId.indexOf(val.skill_id) < 0) {
              return;
            }
            return(
              <option className="option-class" id={ind} value={val.skill_id} key={`${ind}${val.skill_id}`}>
                {val.skillName}
              </option>
            )
          } ) : 
        options.map((val, ind) => (
          <option
            className="option-class"
            hidden={!placeholder && ind === 0}
            value={
              !placeholder && ind === 0
                ? ""
                : !!optionValues
                ? optionValues[ind]
                : val
            }
            key={val}
          >
            {val}
          </option>
        ))}
      </select> */}
    </>
  );
}

SelectComponent.propTypes = {
  handleChange: PropTypes.func,
  selectedvalue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  labelClass: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  placeholder: PropTypes.string,
  className: PropTypes.string,
  multiple: PropTypes.bool,
};

SelectComponent.defaultProps = {
  handleChange: () => null,
  selectedvalue: "",
  options: [],
  name: "",
  disabled: false,
  labelClass: "hidden",
  label: "label",
  required: false,
  placeholder: "",
  className: "",
  multiple: false,
};

export default SelectComponent;
